var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c("UIButton", {
              attrs: {
                processing: _vm.processing,
                disabled: _vm.disabled,
                buttonText: "Mark all notifications as read",
                variant: "outline",
              },
              on: { click: _vm.markAllAsRead },
            }),
          ]
        },
        { markAllAsRead: _vm.markAllAsRead }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }